<template>
  <div id="app">
    <div>
      <button type="button" class="mobile-nav-toggle d-lg-none">
        <i
          class="icofont-navigation-menu"
          v-if="!menuMobileAberto"
          @click="addMobileMenu"
        ></i>
        <i
          class="icofont-close"
          v-if="menuMobileAberto"
          @click="removeMobileMenu"
        ></i>
      </button>
      <!-- ======= Top Bar ======= -->
      <div id="topbar" class="d-none d-lg-flex fixed-top">
        <div class="container d-flex">
          <div class="contact-info ml-auto p-0">
            <i class="icofont-support-faq"></i>
            <a
              href="#"
              data-toggle="modal"
              data-target="#modal_passo_a_passo"
              class="mr-4"
              >Ajuda</a
            >
          </div>
          <div class="contact-info p-0">
            <i class="icofont-envelope"></i>
            <a
              href="#"
              data-toggle="modal"
              data-target="#modal_contato"
              class="mr-3"
              >Contato</a
            >
          </div>
          <div class="social-links">
            <div v-if="!isAuthenticated" class="section-title">
              <h2>
                <a style="margin-right: 10px" a href="#" v-b-modal.modal_login
                  >ENTRAR &nbsp;</a
                >
                |
                <a
                  href="#"
                  id="cadastrar_usuario"
                  v-b-modal.modal_inserir_usuario
                  >CADASTRAR</a
                >
              </h2>
            </div>
            <div>
              <h4 v-if="isAuthenticated">
                <a href="#" @click="logout()">Sair</a>
              </h4>
              <i v-if="isAuthenticated" class="icofont-exit"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ======= Header ======= -->
      <header id="header" class="fixed-top">
        <div class="container d-flex align-items-center">
          <h1 align="center">
            <a href="#"
              ><img
                src="@/assets/img/terranossa_s_sebrae.jpg"
                width="70%"
                height="70%" /><span></span
            ></a>
          </h1>
          <nav class="nav-menu d-none d-lg-block">
            <ul>
              <li v-if="!isAdmin" class="drop-down">
                <a href="#" onmouseover="$('#menu_produtor').show()"
                  >Sou produtor</a
                >
                <ul id="menu_produtor">
                  <li>
                    <a
                      v-if="isAuthenticated && !isOutros"
                      href="#"
                      v-b-modal.modal_cadastro_produto
                      >Anunciar Produto</a
                    >
                    <a
                      v-if="!isAuthenticated || isOutros"
                      href="#"
                      v-b-modal.modal_conteudo_restrito
                      >Anunciar Produto</a
                    >
                  </li>
                  <li>
                    <a
                      v-if="isAuthenticated && !isOutros"
                      href="#"
                      v-b-modal.modal_gerenciar_produtos
                      >Gerenciar meus Produtos anunciados</a
                    >
                  </li>
                  <li>
                    <a
                      style="cursor: pointer"
                      onclick="$('#btn_vender').click();$('#menu_produtor').hide()"
                    >
                      Encontrar Compradores<br />
                      <p>Mercados varejistas,<br />restaurantes, etc</p>
                    </a>
                  </li>

                  <!-- OCULTANDO A CHAMADA PÚBLICA PARA TODOS OS USUÁRIOS NÃO ADMIN -->

                  <li v-if="isAuthenticated && isAdmin">
                    <a
                      v-if="isAuthenticated"
                      href="#"
                      v-b-modal.modal_prefeituras
                      onclick="$('#menu_produtor').hide()"
                      @click="saveModalChamadaPublicaLog()"
                    >
                      Forneça para Prefeituras<br />
                      <p>Venda para Merenda Escolar</p>
                    </a>
                    <a
                      v-if="!isAuthenticated"
                      href="#"
                      v-b-modal.modal_conteudo_restrito
                      @click="saveModalChamadaPublicaLog()"
                      >Forneça para Prefeituras</a
                    >
                  </li>
                  <li>
                    <a
                      href="#featured-services"
                      onclick="$('#menu_produtor').hide()"
                    >
                      Acesse outros conteúdos<br />
                      <p>
                        Notícias, chamadas públicas,<br />regularização,
                        capacitações
                      </p>
                    </a>
                  </li>
                  <li>
                    <a href="#counts" onclick="$('#menu_produtor').hide()">
                      Quem Somos<br />
                    </a>
                  </li>
                  <li v-if="isAuthenticated">
                    <a
                      href="#"
                      @click="editarUsuario(usuarioAtivo[0])"
                      v-b-modal.modal_inserir_usuario
                      >Editar meus dados</a
                    >
                  </li>
                </ul>
              </li>

              <li v-if="!isAdmin" class="drop-down">
                <a href="#" onmouseover="$('#menu_vendedor').show()"
                  >Sou comprador</a
                >
                <ul id="menu_vendedor">
                  <li>
                    <a href="#hero" onclick="$('#btn_comprar').click()"
                      >Encontrar Produtores</a
                    >
                  </li>
                  <li>
                    <a
                      v-if="isAuthenticated && !isOutros"
                      href="#"
                      v-b-modal.modal_anunciar_demanda
                      >Anunciar Demanda</a
                    >
                    <a
                      v-if="!isAuthenticated || isOutros"
                      href="#"
                      v-b-modal.modal_conteudo_restrito
                      >Anunciar Demanda</a
                    >
                  </li>
                  <li>
                    <a
                      v-if="isAuthenticated"
                      href="#"
                      v-b-modal.modal_anunciar_demanda
                      >Gerenciar minhas Demandas</a
                    >
                  </li>
                  <li>
                    <a href="#counts" onclick="$('#menu_vendedor').hide()">
                      Quem Somos<br />
                    </a>
                  </li>
                  <li v-if="isAuthenticated">
                    <a
                      href="#"
                      @click="editarUsuario(usuarioAtivo[0])"
                      v-b-modal.modal_inserir_usuario
                      >Editar meus dados</a
                    >
                  </li>
                </ul>
              </li>

              <li v-if="isAdmin" class="drop-down">
                <a href="#" onmouseover="$('#menu_admin').show()"
                  >Painel do Administrador</a
                >
                <ul id="menu_admin">
                  <li>
                    <a href="#EditMunicipio" @click="editMunicipio()"
                      >Edição de Municipios</a
                    >
                  </li>
                  <li>
                    <a href="#EditBanner" @click="editBanner('cadastro')"
                      >Cadastro de Banners</a
                    >
                  </li>
                  <li>
                    <a href="#EditCard" @click="editCard('cadastro')"
                      >Cadastro de Cards</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaBanner"
                      @click="
                        limparMenu();
                        AdminListaBanner = true;
                      "
                      onclick="$('#menu_admin').hide()"
                      >Editar / Excluir banners</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaCards"
                      @click="
                        limparMenu();
                        AdminListaCards = true;
                      "
                      id="link_buscar_cards"
                      onclick="$('#menu_admin').hide();"
                      >Editar / Excluir Cards</a
                    >
                  </li>
                  <li v-if="isAuthenticated">
                    <a
                      href="#"
                      @click="editarUsuario(usuarioAtivo[0])"
                      v-b-modal.modal_inserir_usuario
                      >Editar meus dados</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaProduto"
                      @click="listarProdutores()"
                      id="link_buscar_produtores"
                      onclick="$('#menu_admin').hide()"
                      >Listar produtores cadastrados</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaComprador"
                      @click="listarCompradores()"
                      id="link_buscar_comprador"
                      onclick="$('#menu_admin').hide();"
                      >Listar compradores cadastrados</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaOutrosUsuarios"
                      @click="listarOutrosUsuarios()"
                      onclick="$('#menu_admin').hide()"
                      id="link_listar_outros_usuarios"
                      >Listar outros usuários cadastrados</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaProdutosAnunciados"
                      @click="listarProdutosAnunciados()"
                      id="link_listar_produtos_anunciados"
                      onclick="$('#menu_admin').hide()"
                      >Listar produtos anunciados</a
                    >
                  </li>
                  <li>
                    <a
                      href="#ListaDemandasAnunciadas"
                      @click="listarDemandasAnunciadas()"
                      id="link_listar_demandas_anunciadas"
                      onclick="$('#menu_admin').hide()"
                      >Listar demandas cadastradas</a
                    >
                  </li>
                  <li>
                    <a href="#EstatisticaUso" @click="listarEstatisticasUso"
                      >Estatísticas de Uso</a
                    >
                  </li>
                  <li>
                    <a href="#ChamadaPublica" @click="listarChamadasPublicas()"
                      >Administrar Chamadas Públicas</a
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <!-- .nav-menu -->

          <!-- .nav menu mobile -->
          <nav v-if="menuMobileAberto" class="mobile-nav d-lg-none">
            <ul>
              <li class="drop-down">
                <a
                  href="#"
                  @click="closeMobileMenu()"
                  data-toggle="modal"
                  data-target="#modal_contato"
                  >Contato</a
                >
              </li>
              <li class="drop-down">
                <a
                  @click="
                    closeMobileMenu();
                    $bvModal.show('modal_login');
                  "
                  style="margin-right: 10px"
                  href="#"
                  >Entrar</a
                >
              </li>
              <li class="drop-down">
                <a
                  @click="
                    closeMobileMenu();
                    $bvModal.show('modal_inserir_usuario');
                  "
                  href="#"
                  id="cadastrar_usuario"
                  >Cadastrar</a
                >
              </li>
              <li class="drop-down" v-if="isAuthenticated">
                <a
                  href="#"
                  @click="
                    editarUsuario(usuarioAtivo[0]);
                    $bvModal.show('modal_inserir_usuario');
                  "
                  >Editar meus dados</a
                >
              </li>
              <li v-if="isAuthenticated" class="drop-down">
                <a
                  href="#"
                  @click="
                    logout();
                    closeMobileMenu();
                  "
                  >Sair</a
                >
              </li>
            </ul>
          </nav>
          <div
            v-if="menuMobileAberto"
            class="mobile-nav-overly"
            style="display: block"
          ></div>
          <!-- END NAV MOBILE MENU -->
          <h1 align="center">
            <a href="index.html"
              ><img
                src="@/assets/img/sebrae_a.png"
                width="40%"
                height="40%" /><span></span
            ></a>
          </h1>

          <!-- OCULTANDO A CHAMADA PÚBLICA PARA TODOS OS USUÁRIOS NÃO ADMIN -->

          <div v-if="isAuthenticated && isAdmin">
            <h1 align="center">
              <a
                v-if="isAuthenticated"
                href="#"
                v-b-modal.modal_prefeituras
                onclick="$('#menu_produtor').hide()"
                @click="saveModalChamadaPublicaLog()"
                ><img
                  v-if="isAuthenticated"
                  src="@/assets/img/chamadas-publicas.png" /><span></span
              ></a>
            </h1>
            <h1 align="center">
              <a
                v-if="!isAuthenticated"
                href="#"
                v-b-modal.modal_conteudo_restrito
                @click="saveModalChamadaPublicaLog()"
                ><img
                  v-if="!isAuthenticated"
                  src="@/assets/img/chamadas-publicas.png" /><span></span
              ></a>
            </h1>
          </div>
        </div>
        <div class="slogan">
          <p align="center">
            Diminuindo a distância entre
            <span>produtores rurais e compradores locais</span>
          </p>
        </div>
      </header>
      <!-- End Header -->
      <router-view />

      <section
        id="ListaComprador"
        class="tabela_busca_comprar"
        v-if="AdminListaComprador"
        :compradores="compradores"
        @modificar-comprador-selecionado="modificarCompradorSelecionado"
      >
        <lista-comprador></lista-comprador>
      </section>

      <!-- ADMIN - LISTAR PRODUTO -->
      <section
        id="ListaProduto"
        class="tabela_busca_comprar"
        v-if="AdminListaProduto"
        :produtos="produtos"
        @modificar-produto-selecionado="modificarProdutoSelecionado"
      >
        <lista-produto></lista-produto>
      </section>

      <!-- ADMIN - LISTAR PRODUTO -->
      <section
        id="ChamadaPublica"
        class="tabela_busca_comprar"
        v-if="AdminChamadaPublica"
      >
        <AdministracaoChamadaPublica></AdministracaoChamadaPublica>
      </section>

      <!-- ADMIN - LISTAR PRODUTOS ANUNCIADOS -->
      <section
        id="EstatisticaUso"
        class="tabela_busca_comprar"
        v-if="AdminEstatisticaUso"
      >
        <DashboardLog></DashboardLog>
      </section>

      <!-- Modal Banner -->
      <section
        id="EditBanner"
        class="tabela_busca_comprar"
        v-if="AdminEditBanner"
      >
        <modal-inserir-banner
          :payload="$store.state.banner"
        ></modal-inserir-banner>
      </section>

      <!-- Modal Card -->
      <section id="EditCard" class="tabela_busca_comprar" v-if="AdminEditCard">
        <ModalInserirCard :payload="$store.state.card"></ModalInserirCard>
      </section>

      <!-- ADMIN - LISTAR PRODUTOS ANUNCIADOS -->
      <section
        id="ListaProdutosAnunciados"
        class="tabela_busca_comprar"
        v-if="AdminListaProdutoAnunciado"
        :produtosAnunciados="produtosAnunciados"
        @modificar-produto-anunciado-selecionado="
          modificarProdutoAnunciadoSelecionado
        "
      >
        <lista-produtos-anunciados></lista-produtos-anunciados>
      </section>

      <!-- ADMIN - LISTAR DEMANDAS ANUNCIADOS -->
      <section
        id="ListaDemandasAnunciadas"
        class="tabela_busca_comprar"
        v-if="AdminListaDemandaAnunciada"
        :demandasAnunciadas="demandasAnunciadas"
        @modificar-demanda-anunciada-selecionada="
          modificarDemandaAnunciadaSelecionada
        "
      >
        <lista-demandas-anunciadas></lista-demandas-anunciadas>
      </section>

      <!-- ADMIN - LISTAR CARDS -->
      <section
        id="ListaCards"
        class="tabela_busca_comprar"
        v-if="AdminListaCards"
        :cards="cards"
      >
        <lista-cards @editCard="editCard('editar')"></lista-cards>
      </section>

      <!-- ADMIN - Editar Municipios -->
      <section
        id="EditMunicipio"
        class="tabela_busca_comprar"
        v-if="AdminEditMunicipio"
      >
        <EditarMunicipio></EditarMunicipio>
      </section>

      <!-- ADMIN - LISTAR CARDS -->
      <section
        id="ListaOutrosUsuarios"
        class="tabela_busca_comprar"
        v-if="AdminListaOutrosUsuarios"
        :cards="cards"
      >
        <lista-outros-usuarios-cadastrados></lista-outros-usuarios-cadastrados>
      </section>

      <section
        id="ListaBanner"
        class="tabela_busca_comprar"
        v-if="AdminListaBanner"
        :cards="cards"
      >
        <lista-banner @editBanner="editBanner('editar')"></lista-banner>
      </section>

      <section
        v-if="
          AdminListaComprador ||
          AdminListaProduto ||
          AdminListaCards ||
          AdminListaProdutoAnunciado ||
          AdminListaDemandaAnunciada
        "
        id="voltar"
        class="tabela_busca_comprar"
      >
        <div class="container aos-init aos-animate" data-aos="fade-up">
          <div class="section-title">
            <div class="row align my-auto">
              <h2>
                <a
                  href="#"
                  @click="
                    AdminListaComprador = false;
                    AdminListaProduto = false;
                    AdminListaCards = false;
                  "
                  align="my-auto"
                >
                  Voltar
                </a>
              </h2>
            </div>
          </div>
        </div>
      </section>

      <!-- ======= Footer ======= -->
      <footer id="footer" class="footer-top">
        <div class="footer-top">
          <div class="container" align="center">
            <h1>Quem Somos</h1>
            <br />
            <h4 align="justify">
              O Sebrae Rio tem como objetivo fomentar o empreendedorismo e a
              formalização de empresas, estimulando a geração de emprego e
              renda. Com importante papel no crescimento econômico fluminense,
              desenvolve projetos de norte a sul do Estado. Suas ações levam em
              consideração as vocações econômicas locais.
            </h4>
            <h4 align="justify">
              São diversos projetos com foco na competitividade, na
              sustentabilidade e nos diferenciais competitivos que podem ajudar
              as micro e pequenas empresas a vencerem os crescentes desafios do
              mercado.
            </h4>
            <h4 align="justify">
              Um desses projetos é o Terra Nossa, com o slogan "Da Terra ao
              Mercado", o objetivo é apresentar outras oportunidades de mercado
              aos produtores rurais e mostrar que todos ganham quando a venda é
              feita direta de produtores locais para mercados locais. O preço é
              melhor para todos os públicos – mercados, produtores e,
              principalmente para os consumidores que ganham em preço e
              sobretudo em qualidade, com um produto fresquinho, colhido da sua
              cidade ou região.
            </h4>
            <h4 align="justify">
              A iniciativa visa ampliar mercado para os empreendedores, por meio
              de capacitações, consultorias e da plataforma Terra Nossa
              Negócios.
            </h4>
          </div>
        </div>

        <div class="container py-4">
          <div class="copyright">
            © Copyright
            <strong
              ><span
                ><img src="@/assets/img/terranossa_texto.png" width="10%" /> | |
                O Sebrae não se responsabiliza pelas informações anunciadas
                pelos produtores e compradores parceiros. | |
              </span></strong
            >
            <img src="@/assets/img/sebrae_a.png" width="7%" />
          </div>
          <div class="credits"></div>
        </div>
      </footer>
      <!-- End Footer -->

      <div id="preloader" v-if="loading"></div>
      <a href="#" class="back-to-top"><i class="icofont-simple-up"></i></a>
    </div>

    <!-- Modal Passo a passo -->
    <modal-passo-a-passo></modal-passo-a-passo>

    <!-- Modal Passo a passo -->
    <modal-passo-a-passo-comprador></modal-passo-a-passo-comprador>

    <!--Modal: Inserir Usuário-->
    <modal-inserir-produto></modal-inserir-produto>

    <!--Modal: Registro Form-->
    <modal-inserir-usuario></modal-inserir-usuario>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ModalInserirProduto from "@/modules/home/components/ModalInserirProduto";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
import ListaCards from "@/modules/admin/components/ListaCards";
import ListaProduto from "@/modules/admin/components/ListaProduto";
import ListaProdutosAnunciados from "@/modules/admin/components/ListaProdutosAnunciados";
import ListaDemandasAnunciadas from "@/modules/admin/components/ListaDemandasAnunciadas";
import ListaComprador from "@/modules/admin/components/ListaComprador";
import ListaBanner from "@/modules/admin/components/ListaBanner";
import ModalPassoAPasso from "@/modules/home/components/ModalPassoAPasso";
import ModalPassoAPassoComprador from "@/modules/home/components/ModalPassoAPassoComprador";
import ModalInserirUsuario from "@/modules/home/components/ModalInserirUsuario";
import { usuarioAPI, produtoAPI } from "@/modules/home";
import { modalChamadaPublicaLogAPI } from "@/modules/log";
import DashboardLog from "./modules/admin/components/DashboardLog";
import AdministracaoChamadaPublica from "./modules/admin/components/AdministracaoChamadaPublica";
import ListaOutrosUsuariosCadastrados from "./modules/admin/components/ListaOutrosUsuariosCadastrados.vue";
import ModalInserirBanner from "@/modules/home/components/ModalInserirBanner";
import ModalInserirCard from "@/modules/home/components/ModalInserirCard";
import EditarMunicipio from "@/modules/admin/components/EditarMunicipio";

export default {
  components: {
    ModalInserirProduto,
    ModalPassoAPasso,
    ModalPassoAPassoComprador,
    ListaCards,
    ListaComprador,
    ListaProduto,
    ListaProdutosAnunciados,
    ListaDemandasAnunciadas,
    ModalInserirUsuario,
    ListaBanner,
    DashboardLog,
    AdministracaoChamadaPublica,
    ListaOutrosUsuariosCadastrados,
    ModalInserirBanner,
    ModalInserirCard,
    EditarMunicipio,
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isAuthenticated",
      "user",
      "isOutros",
      "tutorialCache",
    ]),
  },
  created() {
    var token = localStorage.getItem("token") || null;
    var localStorageUser = localStorage.getItem("user") || {};
    var user = JSON.parse(localStorage.getItem("user")) || {};

    if (token !== null) {
      this.usuarioLogado = user;
      this.setToken(token);
      this.setUser(localStorageUser);
      if (user.permissoes.length > 0) {
        for (var i = 0; i < user.permissoes.length; i++) {
          if (user.permissoes[i].permissaoId === 5) {
            this.setOutros(true);
          }
        }
      }
    }

    if (token !== null && user.grupo.nome === "Admin") this.setAdmin(true);
  },
  methods: {
    ...mapActions([
      "setToken",
      "setUser",
      "setAdmin",
      "logout",
      "setOutros",
      "setLoading",
    ]),
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (err) => {
          if (this.isAuthenticated && err.response.status === 401) {
            console.log("err.response.status: ", err.response.status);
            this.logout();
          }
          return Promise.reject(err);
        }
      );
    },
    limparMenu() {
      this.AdminListaComprador = false;
      this.AdminListaProduto = false;
      this.AdminListaCards = false;
      this.exibeBuscaVender = false;
      this.AdminListaDemandaAnunciada = false;
      this.AdminListaBanner = false;
      this.AdminListaProdutoAnunciado = false;
      this.AdminEstatisticaUso = false;
      this.AdminChamadaPublica = false;
      this.AdminListaOutrosUsuarios = false;
      this.AdminEditBanner = false;
      this.AdminEditCard = false;
      this.AdminEditMunicipio = false;
    },
    openMenu(menu) {
      const value = {
        CARD: {
          topicos: [{ topico: "", texto: "", imagens: [] }],
          imagens: [],
          restrito: false,
          avisos: 0,
        },
        BANNER: { avisos: 0 },
      };
      this.$store.commit("SET_" + menu, value[menu]);
      $("#menu_admin").hide();
    },
    addMobileMenu() {
      document.body.classList.add("mobile-nav-active");
      this.menuMobileAberto = true;
    },
    removeMobileMenu() {
      document.body.classList.remove("mobile-nav-active");
      this.menuMobileAberto = false;
    },
    menuProdutorMobileChange() {
      if (this.menuProdutorMobileAberto) {
        document.getElementById("menu_produtor_mobile").style.display = "none";
        this.menuProdutorMobileAberto = false;
      } else {
        this.menuProdutorMobileAberto = true;
        document.getElementById("menu_produtor_mobile").style.display = "block";
      }
    },
    menuVendedorMobileChange() {
      if (this.menuVendedorMobileAberto) {
        document.getElementById("menu_vendedor_mobile").style.display = "none";
        this.menuVendedorMobileAberto = false;
      } else {
        document.getElementById("menu_vendedor_mobile").style.display = "block";
        this.menuVendedorMobileAberto = true;
      }
    },
    listarCompradores() {
      this.limparMenu();
      this.AdminListaComprador = true;
      this.exibeBuscaVender = true;
      this.setLoading(true);
      usuarioAPI
        .compradores(this.buscaComprador)
        .then((resp) => {
          this.compradores = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    listarOutrosUsuarios() {
      this.limparMenu();
      this.AdminListaOutrosUsuarios = true;
    },
    listarProdutores() {
      this.limparMenu();
      this.AdminListaProduto = true;
      this.exibeBuscaComprar = true;
      this.setLoading(true);
      usuarioAPI
        .produtores()
        .then((resp) => {
          this.produtos = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    editBanner(tipo) {
      if (tipo === "cadastro") {
        this.$store.commit("SET_BANNER", {});
      }
      this.limparMenu();
      this.AdminEditBanner = true;
    },
    editMunicipio() {
      this.limparMenu();
      this.AdminEditMunicipio = true;
    },
    editCard(tipo) {
      if (tipo === "cadastro") {
        this.$store.commit("SET_CARD", {
          topicos: [{ topico: "", texto: "", imagens: [] }],
          imagens: [],
          restrito: false,
          avisos: 0,
          linha: null,
          ordem: null,
          titulo: null,
          tituloPequeno: null,
          texto: null,
        });
      }
      this.limparMenu();
      this.AdminEditCard = true;
    },
    listarDemandasAnunciadas() {
      this.limparMenu();
      this.AdminListaDemandaAnunciada = true;
    },
    listarProdutosAnunciados() {
      this.limparMenu();
      this.AdminListaProdutoAnunciado = true;
    },
    listarEstatisticasUso() {
      this.limparMenu();
      this.AdminEstatisticaUso = true;
    },
    listarChamadasPublicas() {
      this.limparMenu();
      $("#menu_admin").hide();
      this.AdminChamadaPublica = true;
    },

    modificarProdutoSelecionado(produto) {
      this.produtoSelecionado = produto;
    },
    modificarProdutoAnunciadoSelecionado(produtoAnunciado) {
      this.produtoAnunciadoSelecionado = produtoAnunciado;
    },
    modificarDemandaAnunciadaSelecionada(demandaAnunciada) {
      this.demandaAnunciadaSelecionada = demandaAnunciada;
    },
    modificarCompradorSelecionado(comprador) {
      this.compradorSelecionado = comprador;
    },
    editarUsuario(usuario) {
      // this.closeMobileMenu()
      this.limparMenu();
      $("#modal_inserir_usuario").modal();
      this.$store.commit("SET_USUARIO", usuario);
    },
    closeMobileMenu() {
      document
        .getElementsByClassName("mobile-nav-toggle d-lg-none")[0]
        .getElementsByTagName("i")[0]
        .click();
    },
    saveModalChamadaPublicaLog() {
      modalChamadaPublicaLogAPI.create({});
    },
  },
  mounted() {
    this.enableInterceptor();
    this.limparMenu();

    if (!localStorage.getItem("tutorial")) {
      $("#modal_passo_a_passo").modal();
    }
    usuarioAPI
      .usuarios(this.usuarioLogado.usuarioId)
      .then((resp) => {
        this.usuarioAtivo = resp.data;
      })
      .catch((resp) => {
        this.setLoading(false);
      });
  },
  data() {
    return {
      menuMobileAberto: false,
      menuProdutorMobileAberto: false,
      menuVendedorMobileAberto: false,
      AdminListaComprador: false,
      AdminListaCards: false,
      AdminListaBanner: false,
      AdminListaProduto: false,
      AdminListaProdutoAnunciado: false,
      AdminListaDemandaAnunciada: false,
      AdminEstatisticaUso: false,
      AdminChamadaPublica: false,
      AdminListaOutrosUsuarios: false,
      AdminEditBanner: false,
      AdminEditCard: false,
      AdminEditMunicipio: false,
      compradorSelecionado: {
        municipio: {},
      },
      cards: [],
      compradores: [],
      buscaComprador: null,
      exibeTabelaProdutor: false,
      exibeTabelaComprador: false,
      exibeBuscaComprar: false,
      exibeBuscaVender: false,
      produtos: [],
      buscaProduto: null,
      produtosAnunciados: [],
      demandasAnunciadas: [],
      produtoAnunciadoSelecionado: {},
      demandaAnunciadaSelecionada: {},

      produtoSelecionado: {
        propriedade: {
          municipio: {},
          usuario: {},
        },
      },
      usuarioLogado: {},
      usuarioAtivo: {},
    };
  },
};
</script>

<style lang="scss">
@import "./style.scss";

#menu_admin {
  max-height: 70vh;
  overflow: auto;
}
</style>
